module.exports = __webpack_public_path__ + "img/arrow-left.7768b188.svg";